import { getErrorMessage } from "@/core/services";
import { useAsyncList } from "@/ds";
import { listarDistribuicoes } from "@/modules/financeiro-configuracoes";
import type {
  DistribuicaoColetor,
  ListarDistribuicoesParams,
} from "@/modules/financeiro-configuracoes";
import {
  DISTRIBUICOES_ERROR_MESSAGE,
  DISTRIBUICOES_FORBIDDEN_MESSAGE,
} from "../distribuicoes.constants";

export function useDistribuicoesDados(
  filtro: ListarDistribuicoesParams = {},
  { enabled = true }: { enabled?: boolean } = {},
) {
  const lista = useAsyncList<ListarDistribuicoesParams, DistribuicaoColetor>({
    fetcher: async (params, signal) => {
      const distribuicoes = await listarDistribuicoes(params, { signal });
      return { items: distribuicoes, total: distribuicoes.length };
    },
    params: filtro,
    enabled,
    forbiddenMessage: DISTRIBUICOES_FORBIDDEN_MESSAGE,
    errorMessage: DISTRIBUICOES_ERROR_MESSAGE,
    resolveErrorMessage: getErrorMessage,
  });

  return {
    distribuicoes: lista.items,
    carregando: lista.isLoading,
    semPermissao: lista.status === "forbidden",
    erro: lista.status === "error" ? lista.errorMessage : null,
    recarregar: lista.reload,
  };
}
